module.exports = __webpack_public_path__ + "static/media/gray_back.db53954a.png";